//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Index',
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    setTemplate: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    setTemplate: {
      handler: function handler(nVal) {
        if (nVal.success === 1) {
          this.cancelTemplate();
          nVal.success = 0;
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      dialogTemplate: false,
      info: {
        name: '',
        info: '',
        cate_id: ''
      },
      tempLoading: false,
      rules: {
        name: [{
          required: true,
          message: this.$t('access.placeholder05'),
          trigger: 'blur'
        }],
        info: [{
          required: true,
          message: this.$t('access.placeholder06'),
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    openBox: function openBox() {
      this.dialogTemplate = true;
    },
    cancelTemplate: function cancelTemplate() {
      this.dialogTemplate = false;
      this.info.name = '';
      this.info.info = '';
      this.info.cate_id = '';
    },
    // 提交
    handleConfirm: function handleConfirm() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.$emit('handleTemplate', _this.info);
        }
      });
    }
  }
};